import axios from 'axios';
import { appApiUrl } from '../../../utils/appApiOrigin';
import { checkAppSession, peekSessionCache } from '../../../utils/sessionAuth';

const http = axios.create({ withCredentials: true, timeout: 45000 });

export async function hasCloudAudioLibrary() {
  if (typeof window === 'undefined') return false;
  if (peekSessionCache()) return true;
  try {
    return await checkAppSession();
  } catch {
    return false;
  }
}

async function post(path, body) {
  const res = await http.post(appApiUrl(path), body || {});
  if (res.data?.success !== true) {
    const err = new Error(res.data?.message || 'Audio library request failed');
    err.status = res.status;
    throw err;
  }
  return res.data;
}

export async function syncCloudLibrary() {
  return post('/api/audio-player/library/sync');
}

export async function cloudListPlaylists() {
  const data = await post('/api/audio-player/library/playlists/list');
  return data.playlists || [];
}

export async function cloudSavePlaylist(payload) {
  const data = await post('/api/audio-player/library/playlists/save', payload);
  return data.playlist;
}

export async function cloudDeletePlaylist(id) {
  await post('/api/audio-player/library/playlists/delete', { id });
}

export async function cloudListCategories() {
  const data = await post('/api/audio-player/library/categories/list');
  return data.categories || [];
}

export async function cloudSaveCategory(payload) {
  const data = await post('/api/audio-player/library/categories/save', payload);
  return data.category;
}

export async function cloudDeleteCategory(id) {
  await post('/api/audio-player/library/categories/delete', { id });
}

export async function cloudListGenreStations(genreId) {
  const data = await post('/api/audio-player/library/genre-stations/list', genreId ? { genreId } : {});
  return data.genreStations || [];
}

export async function cloudSaveGenreStation(payload) {
  const data = await post('/api/audio-player/library/genre-stations/save', payload);
  return data.station;
}

export async function cloudDeleteGenreStation(id) {
  await post('/api/audio-player/library/genre-stations/delete', { id });
}

export async function cloudSaveTileAppearance(payload) {
  const data = await post('/api/audio-player/library/appearances/save', payload);
  return data.appearance;
}

export async function cloudSaveBrowsePrefs(payload) {
  const data = await post('/api/audio-player/library/prefs/save', payload);
  return data.browsePrefs;
}
